import * as React from 'react';
import { Component } from 'react';
import { MenuWrapper, MenuItem, MenuItemCta } from './Menu.s';
import { proPath, explainPath, discoverPath, aboutPath } from '@config/paths';
import * as ReactDocumentEvent from 'react-document-events';
import debounce = require('lodash/debounce');
import { getScrollTop, getMaxScroll } from '@utils/index';
import { InjectApp, Core } from '@core';
import { History, Location } from 'history';
import { PathPattern } from 'path-pattern';

type MenuProps = {
  app?: Core;
  location: Location;
  discoverPosition: number;
  explainPosition: number;
  aboutPosition: number;
  windowHeight: number;
};

@InjectApp<typeof Menu, {}>()
export class Menu extends Component<MenuProps, {}> {

  private history: History;

  constructor(props: MenuProps) {
    super(props);

    this.onScroll = debounce(this.onScroll, 300).bind(this);

    if (props.app) {
      this.history = props.app.getHistory();
    }
  }

  // componentWillReceiveProps(nextProps: MenuProps) {
  //   const current = this.findCurrentSection(nextProps);
  //   if (this.state.currentSection !== current) {
  //     this.updateLocation(current);
  //     this.setState({ currentSection: current });
  //   }
  // }

  render(): JSX.Element {
    return (
      <MenuWrapper>
        <ReactDocumentEvent
          enabled={!proPath.match(this.props.location)}
          target={window}
          onScroll={this.onScroll}
        />
        <MenuItem isActive={discoverPath.matchExact(this.history.location) !== false} to={discoverPath.compile()}>
          Découvrir
        </MenuItem>
        <MenuItem isActive={explainPath.matchExact(this.history.location) !== false} to={explainPath.compile()}>
          Fonctionnement
        </MenuItem>
        <MenuItem isActive={aboutPath.matchExact(this.history.location) !== false} to={aboutPath.compile()}>
          A propos
        </MenuItem>
        <MenuItemCta to={proPath.compile()} isActive={!!proPath.match(this.props.location)}>
          Espace Pro
        </MenuItemCta>
      </MenuWrapper>
    );
  }

  private onScroll(): void {
    const current = this.findCurrentPath(this.props);
    if (!current) {
      return;
    }
    if (!current.matchExact(this.props.location)) {
      this.updateLocation(current);
    }
  }

  private findCurrentPath(props: MenuProps): PathPattern<{}> | null {
    if (proPath.match(this.props.location)) {
      return null;
    }
    const maxScroll = getMaxScroll(props.windowHeight);
    const scroll = getScrollTop();
    if (scroll > props.aboutPosition || scroll >= maxScroll) {
      return aboutPath;
    }
    if (scroll > props.explainPosition) {
      return explainPath;
    }
    return discoverPath;
  }

  private updateLocation(path: PathPattern<{}>): void {
    if (path.compile() === this.history.location.pathname) {
      return;
    }
    this.history.push({
      pathname: path.compile(),
      state: { fromScroll: true }
    });
  }

}


// WEBPACK FOOTER //
// src/app/src/components/Menu/Menu.tsx